<script>
	import User from '../User.svelte';
</script>

<div class="header">
	<div class="header__user">
		<User />
	</div>
</div>

<style lang="scss">
	.header {
		display: flex;
		align-items: stretch;
		height: 64px;
		background: var(--bg-main-1);
		border-bottom: 1px solid var(--border-gray-1);
		width: 100%;

		&__user {
			display: flex;
			margin-left: auto;
		}

		// &__orgs {
		// 	cursor: pointer;
		// 	display: flex;
		// 	align-items: center;
		// 	padding: 12px 24px 11px;
		// 	font-size: 18px;
		// 	font-weight: 600;

		// 	&:hover {
		// 		> span {
		// 			color: var(--color-1);
		// 			transform: translateY(1px);
		// 		}
		// 	}

		// 	> span {
		// 		transition: all 0.1s;
		// 	}

		// 	> div {
		// 		border-radius: 20px;
		// 		background-color: var(--color-2);
		// 		margin: 0 0 0 5px;

		// 		> span {
		// 			height: 20px;
		// 			min-width: 20px;
		// 			padding: 5px;
		// 			font-size: 12px;
		// 			margin: 1px 1px 0 0;
		// 			display: flex;
		// 			align-items: center;
		// 			justify-content: center;
		// 			font-weight: bold;
		// 			flex-shrink: 0;
		// 			word-break: normal !important;
		// 		}
		// 	}
		// }
	}
</style>
